
import { Component, Vue, Watch } from "vue-property-decorator";
import { IDefaultShippingOrderModel } from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import { searchCustomer, getCustomersKCList } from "@/api/customer";

import { QuotationApproval } from "./types";
import {
  getSalesmanList,
  auditHold,
  removeQuotation,
  generatePI,
  auditPass,
} from "@/api/inquiry";
import {
  getPiList,
  updatePiRemark,
  getPiDeliveryStatus,
  getPiCustomerShipmentStatus,
  confirmOrder,
  invalidPi,
  uncancelPi,
  downloadPiDetail,
  downloadPiTemplate,
  getOverdue,
  searchPiCode,
  PIMangentRemark, downloadPiAllPoLabelInfo, downloadLabelInfo
} from "@/api/proforma";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { deepClone } from "@/utils/deepClone";
import {UserModule} from "@/store/modules/user";

// 查看PI详情的权限
const PI_DETAIL_PERMISSION_CODE = "detail";

@Component({
  name: "salesOrder",
  components: {
    Pagination,
    Issuance: () =>
      import(
        "@/views-oms/sales-order-management/order/components/Issuance.vue"
      ),
  },
})
export default class extends Vue {
  private selectedItem = {} as any;
  private showOver = false;
  private isShowMore = false;
  private isShowMore2 = false;
  private listLoading = true;
  private inventoryShow = false;
  private searchOptions = [];
  private piCode = "";
  private searchCustomerOptions = [];
  private listLoadingKC = false;
  private inventoryList = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any,
  };
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any,
  };
  public listParam = {
    inquirySheetCode: null,
    customerId: null,
    startTime: null,
    endTime: null,
    sellerId: null,
    status: null,
    time: [],
    time2: [],
    code: null,
  };
  private searchCustomerList = "";
  public inventoryCol = [
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      show: true,
      disabled: false,
    },
    {
      label: "入库折后单价",
      prop: "company",
      key: "company",
      show: true,
      disabled: false,
    },
    {
      label: "采购订单号",
      prop: "company",
      key: "company",
      show: true,
      disabled: false,
    },
    {
      label: "库存数量",
      prop: "inventoryQuantity",
      key: "inventoryQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "实用库存数量",
      prop: "company",
      key: "company",
      show: true,
      disabled: false,
    },
    {
      label: "产品单位",
      prop: "company",
      key: "company",
      show: true,
      disabled: false,
    },
    {
      label: "下单时间",
      prop: "company",
      key: "company",
      show: true,
      disabled: false,
    },
    {
      label: "装箱单号",
      prop: "company",
      key: "company",
      show: true,
      disabled: false,
    },
    {
      label: "入库进度",
      prop: "company",
      key: "company",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
  ] as any;
  public searchForm = [
    {
      label: "销售订单号",
      prop: "code",
      key: "code",
      type: "input",
      value: "",
      placeholder: "请输入销售订单号"
    },
    {
      label: "客人简称或编号",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "",
      remote: true,
      remote_method: this.searchCustomer,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "PI生成时间",
      prop: "time",
      key: "time",
      type: "dateTimePicker",
      value: "",
    },
    {
      label: "生产批次号",
      prop: "batchNumber",
      key: "batchNumber",
      type: "input",
      value: "",
      placeholder: "请输入批次号",
    },
    {
      label: "销售员",
      prop: "saleId",
      key: "saleId",
      type: "select",
      options: [],
      value: "",
      placeholder: "全部",
    },
    {
      label: "下单时间",
      prop: "time2",
      key: "time2",
      type: "dateTimePicker",
      value: "",
    },
    {
      label: "订单状态",
      prop: "orderStatus",
      key: "orderStatus",
      type: "select",
      value: "",
      options: [],
      placeholder: "全部",
    },
    {
      label: "发货状态",
      prop: "shipmentStatus",
      key: "shipmentStatus",
      type: "select",
      value: "",
      options: [],
      placeholder: "全部",
    },
    {
      label: "采购订单号",
      prop: "purchaseOrderCode",
      key: "purchaseOrderCode",
      type: "input",
      value: "",
      placeholder: "请输入采购订单号"
    },
  ];
  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      disabled: false,
      fixed: true,
      icon: require("@/assets/images/icon_HT.jpg"),
      icon_key: "closureOrderType",
      icon_value: 'STATE_ROLLBACK',
      icon2: require("@/assets/images/icon_TPKC.jpg"),
      icon_key2: "closureOrderType",
      icon_value2: 'ADJUST_INVENTORY',
    },
    {
      label: "交易公司",
      prop: "company",
      key: "company",
      show: true,
      disabled: false,
      fixed: true,
    },
    {
      label: "PI NO.",
      prop: "code",
      key: "code",
      show: true,
      disabled: false,
      fixed: true,
      type: "link",
      width: 140,
    },
    {
      label: "客人简称",
      prop: "abbreviation",
      key: "abbreviation",
      show: true,
      disabled: false,
      render: (prop, row)=>{
        if (row.pcName && row.pcName.length > 0){
          return `[${row.pcName}]${prop}`
        }
        return prop
      }
    },
    {
      label: "销售经理",
      prop: "saleName",
      key: "saleName",
      show: true,
      disabled: false,
    },
    {
      label: "产品数量",
      prop: "productQuantity",
      key: "productQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "PI金额",
      prop: "proformaInvoiceAmount",
      key: "proformaInvoiceAmount",
      show: true,
      disabled: false,
      show_key: "show1",
      account: ['A','A_B'],
    },
    {
      label: "销售总价",
      prop: "totalCompanyPrice",
      key: "totalCompanyPrice",
      show: true,
      disabled: false,
      show_key: "show1",
      account: ['B','A_B'],
    },
    {
      label: "产品货款",
      prop: "productPayMent",
      key: "productPayMent",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "折算利润率",
      prop: "conversionProfitMargin",
      key: "conversionProfitMargin",
      show: true,
      disabled: false,
      show_key: "show1",
      account: ['A','A_B'],
    },
    {
      label: "定金",
      prop: "deposit",
      key: "deposit",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "其他结算费用",
      prop: "otherSettlementExpenses",
      key: "otherSettlementExpenses",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "结算方式",
      prop: "paymentMethod",
      key: "paymentMethod",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "订单状态",
      prop: "status",
      key: "status",
      show: true,
      disabled: false,
      type: "status",
      typeList: [],
    },
    {
      label: "发货状态",
      prop: "shipmentStatus",
      key: "shipmentStatus",
      show: true,
      disabled: false,
      type: "status",
      typeList: [],
    },
    {
      label: "贴标资料",
      prop: "labelInfo",
      key: "labelInfo",
      show: true,
      disabled: false,
      type: "link_popover_label_info_download",
      popoverVisible:false,
      switch_default: false,
      disabled_key:'labelInfo',
      disabled_value:['不需要打','线下提供'],
      disabled_key2:'status',
      disabled_value2:'WAITING_FOR_ORDER'
    },
    {
      label: "包装提供方",
      prop: "packageProvider",
      key: "packageProvider",
      show: true,
      disabled: false,
    },
    {
      label: "供应商交货数量",
      prop: "supplierDeliveredQty",
      key: "supplierDeliveredQty",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "报关发货数量",
      prop: "customsDeliveredQty",
      key: "customsDeliveredQty",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "未发货数量",
      prop: "unshippedQty",
      key: "unshippedQty",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "超/欠发",
      prop: "overShipped",
      key: "overShipped",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "超/欠发",
      prop: "overShipped",
      key: "overShipped",
      show: true,
      type: "actions",
      show_key: "show2",
      options: [
        {
          prop: "overShipped",
          type: "text",
        },
        {
          name: "查看明细",
          code: "",
          click: "handleOver",
        },
      ],
      width: 120,
    },
    {
      label: "PI生成时间",
      prop: "createdTime",
      key: "createdTime",
      show: true,
      disabled: false,
    },
    {
      label: "下单时间",
      prop: "orderPlacementTime",
      key: "orderPlacementTime",
      show: true,
      disabled: false,
    },
    {
      label: "PO号码",
      prop: "poNumber",
      key: "poNumber",
      show: true,
      disabled: false,
    },
    {
      label: "生产批次",
      prop: "productionBatchNumber",
      key: "productionBatchNumber",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
      length: 255,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      code: ["columnShow"],
      options: [
        // {
        //   name: "下单",
        //   code: "",
        //   click: "handleConfirmOrder",
        //   key: "status",
        //   value: "WAITING_FOR_ORDER",
        // },
        {
          name: "下单管理",
          code: ["order"],
          click: "handleOrderManage",
          key: "status",
          value: "NOT_DELIVERED,DELIVERED_IN_PART,COMPLETED,RECEIVED_AND_PAID",
        },
        {
          name: "下载PI",
          code: '',
          click: "handleDownloadPiA",
          account: ['A', 'A_B'],
          key: "status",
          value:
            "NOT_DELIVERED,DELIVERED_IN_PART,COMPLETED,RECEIVED_AND_PAID"
        },
        {
          name: "下载销售订单",
          code: '',
          click: "handleDownloadPiB",
          account: ['B', 'A_B'],
          key: "status",
          value:
            "NOT_DELIVERED,DELIVERED_IN_PART,COMPLETED,RECEIVED_AND_PAID"
        },
        {
          name: "单据流",
          code: '',
          click: "gotoDocumentFlow"
        },
        // {
        //   name: "修改PI",
        //   code: ['edit'],
        //   click: "handleEdit",
        //   key: "status",
        //   value: "NOT_DELIVERED,DELIVERED_IN_PART"
        // },
        {
          name: "更多",
          type: "more",
          actions: [
            {
              name: "作废",
              code: ['cancel'],
              click: "handleInvalidPi",
              key: "status",
              value: "NOT_DELIVERED,WAITING_FOR_ORDER"
            },
            {
              name: "取消作废",
              code: '',
              click: "handleUncancelPi",
              key: "status",
              value: "CANCELLED"
            },
            {
              name: "发货明细",
              code: "",
              click: "handleView",
              key: "status",
              value:
                "RECEIVED_AND_PAID,COMPLETED,DELIVERED_IN_PART,NOT_DELIVERED",
            },
          ],
        },
      ],
      show: true,
      disabled: false,
      width: 300,
    },
  ] as any;

  created() {
    this.syncPiLinkPermission();
    if (this.$route.query.piCode) {
      this.searchForm[0].value = this.$route.query.piCode as any;
      this.listParam.inquirySheetCode = this.$route.query.piCode as any;
      this.listParam.code = this.$route.query.piCode as any;
      this.init();
    } else {
      this.init();
    }
  }
  activated() {
    this.syncPiLinkPermission();
    if (this.$route.query.piCode) {
      this.searchForm[0].value = this.$route.query.piCode as any;
      this.listParam.inquirySheetCode = this.$route.query.piCode as any;
      this.listParam.code = this.$route.query.piCode as any;
      this.init();
    } else {
      this.init();
    }
  }
  // activated() {
  //   if(this.$route.query.piCode) {
  //     this.searchForm[0].value = this.$route.query.piCode as any
  //     this.searchForm[0].placeholder = this.$route.query.piCode as any
  //     this.listParam.inquirySheetCode = this.$route.query.piCode as any
  //     this.listParam.code = this.$route.query.piCode as any
  //     this.init();
  //   }else{
  //     this.init();
  //   }
  // }

  private init() {
    this.getSalesmanList();
    this.searchCustomer();
    this.getPiCustomerShipmentStatus();
    this.getPiDeliveryStatus();
    this.getList();
  }
  @Watch("$route", { immediate: false, deep: false })
  private handleRouteChange() {
    this.syncPiLinkPermission();
  }
  private syncPiLinkPermission() {
    const piColumn = this.tableCol.find((item) => item.prop === "code");
    if (piColumn) {
      piColumn.type = this.hasPermission(PI_DETAIL_PERMISSION_CODE) ? "link" : "";
    }
  }

  // 是否有PI详情的权限
  private hasPermission(code: string): boolean {
    const meta: any = this.$route.meta || {};
    const buttonCodes = meta.buttonCodes;
    if (Array.isArray(buttonCodes)) {
      return buttonCodes.includes(code);
    }
    return true;
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    const { total, list }: any = await getPiList(params);
    this.table.total = +total;
    this.table.list = list;
    this.table.list.map((e,index) => {
      e.sn = index + 1
    })
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  // 导出excel
  private isExporting = false;

  // 导出
  public handleExport() {
    this.isExporting = true;
    let table = this.tableCol.slice(0, this.tableCol.length - 1);
    let accountType = UserModule.accountType[0];
    const headers = table.filter(col => {
      return (
          !col.account || // account为空
          col.account.length === 0 || // account数组为空
          col.account.some(account => UserModule.accountType.includes(account)) // 有匹配的值
      );
    }).map((v) => v.label);
    const fieldNames = table.filter(col => {
      return (
          !col.account || // account为空
          col.account.length === 0 || // account数组为空
          col.account.some(account => UserModule.accountType.includes(account)) // 有匹配的值
      );
    }).map((v) => v.key);
    console.log(accountType);

    let list = deepClone(this.table.list);
    list.forEach((v) => {
      v.shipmentStatus = this.searchForm[7].options.find(
        (item) => item.id === v.shipmentStatus
      ).name;
      v.status = this.searchForm[6].options.find(
        (item) => item.id === v.status
      ).name;
    });
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `PI管理-${new Date()}`
    );
    this.isExporting = false;
  }

  //  删除
  public async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 审批通过
  public async handleAuditPass(scope) {
    this.$confirm("确定审批通过吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditPass(scope.row.approvalRecordId);
        this.$notify({
          title: "成功",
          message: "审批通过",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private handlePI(scope) {
    this.$alert(scope.row.approvalRecordId, "PI号码", {
      confirmButtonText: "复制",
      callback: () => {
        this.h5Copy(scope.row.approvalRecordId);
      },
    });
  }

  // 填写备注
  public async handleRemark(item) {
    try {
      let data = {
        remark: item.remark
      }
      await PIMangentRemark(item.id, data);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }

  private KCCustermId = "";

  private async changeSearchCustomerOptions(e) {
    if (e && e !== "page") {
      this.loading = true;
      this.KCCustermId = e;
      const params = {
        pageNumber: this.inventoryList.pageNumber,
        pageSize: this.inventoryList.pageSize,
      };
      this.listLoadingKC = false;
      const { total, list }: any = await getCustomersKCList(e, params);
      this.inventoryList.total = +total;
      this.inventoryList.list = list;
      this.loading = false;
      setTimeout(() => {
        this.listLoadingKC = false;
      }, 0.3 * 1000);
    } else if (e === "page") {
      this.loading = true;
      const params = {
        pageNumber: this.inventoryList.pageNumber,
        pageSize: this.inventoryList.pageSize,
      };
      this.listLoadingKC = false;
      const { total, list }: any = await getCustomersKCList(
        this.KCCustermId,
        params
      );
      this.inventoryList.total = +total;
      this.inventoryList.list = list;
      this.loading = false;
      setTimeout(() => {
        this.listLoadingKC = false;
      }, 0.3 * 1000);
    }
  }

  private changeValuePiCode(e) {
    const input = document.createElement("input");
    document.body.appendChild(input);
    input.setAttribute("value", e);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    this.$notify({
      title: "成功",
      message: "复制成功",
      type: "success",
      duration: 2000,
    });
  }

  private h5Copy(content) {
    if (!document.queryCommandSupported("copy")) {
      // 不支持
      return false;
    }
    let textarea = document.createElement("textarea") as any;
    textarea.value = content;
    textarea.readOnly = "readOnly";
    document.body.appendChild(textarea);
    textarea.select(); // 选择对象
    textarea.setSelectionRange(0, content.length); // 核心
    let result = document.execCommand("copy"); // 执行浏览器复制命令
    textarea.remove();
    this.$notify({
      title: "成功",
      message: "复制成功",
      type: "success",
      duration: 2000,
    });
    return result;
  }

  private async getSalesmanList() {
    const res: any = await getSalesmanList();
    this.searchForm[4].options = res;
  }

  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[1].options = res;
    this.searchCustomerOptions = res;
  }

  private async searchPiCode(name = "") {
    if (!name) {
      name = " ";
    }
    if (name.length >= 3) {
      const res: any = await searchPiCode(name);
      this.searchOptions = res;
    }
  }

  private async getPiCustomerShipmentStatus() {
    const res: any = await getPiCustomerShipmentStatus();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.searchForm[7].options = res;
    this.tableCol.find((item) => item.key === "shipmentStatus").typeList = res;
  }

  private async getPiDeliveryStatus() {
    const res: any = await getPiDeliveryStatus();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.searchForm[6].options = res;
    this.tableCol.find((item) => item.key === "status").typeList = res;
  }

  public querySearch(data) {
    const params = Object.assign({}, data);
    const { time, time2, ...rest } = params;
    if (time && time.length) {
      rest.piStartTime = time[0];
      rest.piEndTime = time[1];
    }
    if (time2 && time2.length) {
      rest.orderStartTime = time2[0];
      rest.orderEndTime = time2[1];
    }
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }

  private async handleCustomer() {
    // this.inventoryShow = true;
    this.$router.push(`/guestsInStock`);
  }

  private linkClick(scope) {
    if (scope.column.property === 'labelInfo') {
      this.tableCol[15].popoverVisible = true;
    }else {
      if (!this.hasPermission(PI_DETAIL_PERMISSION_CODE)) {
        return;
      }
      this.$router.push(`/PIDetails?id=${scope.row.id}`);
    }
  }

  private handleEdit(scope) {
    let item = JSON.stringify(scope.row);
    if (item.indexOf("&") != -1) {
      item = item.replace("&", "replace");
    }
    this.$router.push(`/revisePI?id=${scope.row.id}&item=${item}`);
  }

  private handleOrderManage(scope) {
    this.$router.push(
      `/orderManagement?id=${scope.row.id}&code=${scope.row.code}`
    );
  }

  private async handleConfirmOrder(scope) {
    await confirmOrder(scope.row.id,null);
    this.getList();
  }

  private async handleInvalidPi(scope) {
    this.$confirm("确定作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await invalidPi(scope.row.id)
          .then((res) => {
            this.confirmSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  // 下载PI,账套A
  public async handleDownloadPiA(scope) {
    await downloadPiTemplate({ id: scope.row.id, account: "A" });
  }

  // 下载PI,账套B
  public async handleDownloadPiB(scope) {
    await downloadPiTemplate({ id: scope.row.id, account: "B" });
  }

  private handleOver(scope) {
    this.selectedItem = scope.row;
    this.showOver = true;
  }

  // PI跳转单据流
  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "PI", documentId: data.row.id },
    });
  }

  private async handleUncancelPi(scope) {
    this.$confirm("确定取消作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await uncancelPi(scope.row.id)
          .then((res) => {
            this.confirmSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  // 挂起
  private async handleAuditHold(scope) {
    this.$prompt("请输入挂起原因", "挂起", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "textarea",
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await auditHold({
          id: scope.row.approvalRecordId,
          remark: value,
        });
        this.getList();
      })
      .catch(() => {
        // empty
      });
  }

  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 点击是否展示所有产品号码
  private showMore() {
    this.isShowMore = !this.isShowMore;
  }

  private showMore2() {
    this.isShowMore2 = !this.isShowMore2;
  }

  private selectedRows: IDefaultShippingOrderModel[] = [];

  private onSelectionChange(rows: IDefaultShippingOrderModel[]) {
    this.selectedRows = rows;
  }

  private async downloadLabelInfo(row) {
     const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      await downloadPiAllPoLabelInfo(row.row.id, row.changeState);
    } catch (err) {
      console.error(err);
    }finally {
        loading.close();
      this.getList();
    }
  }
  private async downloadAllLabelInfo(row) {
     const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
    await downloadLabelInfo(row.row.id);
    }catch (err) {
      console.error(err);
    }finally {
      loading.close();
    }
  }
}
